import React from "react";
export const LanguageModal = ({ show, onClose, onSelectLanguage }) => {
  if (!show) return null; 
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        paddingTop: "80px",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: "24px 32px",
          minWidth: "320px",
          maxWidth: "90%",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
          textAlign: "center",
          animation: "fadeInDown 0.3s ease-out",
        }}
      >
        <h3 style={{ marginBottom: "20px", fontSize: "18px", color: "#333" }}>
          🌐 Select Report Language
        </h3>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={() => onSelectLanguage("en")}
            style={{
              padding: "10px 18px",
              borderRadius: "6px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              transition: "background-color 0.2s",
            }}
          >
            English
          </button>
          <button
            onClick={() => onSelectLanguage("tet")}
            style={{
              padding: "10px 18px",
              borderRadius: "6px",
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              transition: "background-color 0.2s",
            }}
          >
            Tetum
          </button>
        </div>
        <button
          onClick={onClose}
          style={{
            marginTop: "20px",
            padding: "8px 16px",
            backgroundColor: "#6c757d",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};